export const GET_PERMISSIONS_LIST_REQUEST = "Permissions/GET_PERMISSIONS_LIST_REQUEST";
export const GET_PERMISSIONS_LIST_SUCCESS = "Permissions/GET_PERMISSIONS_LIST_SUCCESS";
export const GET_PERMISSIONS_LIST_FAILURE = "Permissions/GET_PERMISSIONS_LIST_FAILURE";